<template>
    <div class="table_wrapper min-h-full" v-if="show && visibility">
        <div class="title_table ">
            <div class="title_settings">
                <div class="table_title">{{ table_title }}</div>
                <AppSearch @search="getSearch" />
                <div class="close_btn_div">
                    <div style=" display: flex; gap: 0.5rem;">
                        <span>registos:</span>
                        <select v-model="perPage" style="color: var(--icon); border-radius: 0.5rem; background-color: var(--fundoApp);">
                            <option v-for="option in perPageOptions" :value="option">{{ option }}</option>
                        </select>
                    </div>
                    <!-- <AppTableFilter :filter_data="filter_data" @update-filter="updateFilter" /> -->
                    
                    <!-- <AppButton  v-bind:visibility="true"  left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @close="close" :width=23
                        :height=23 /> -->
                </div>
            </div>
        </div>

        <table class="table-auto w-full md:w-auto">
            <thead>
                <tr>
                    <th v-for="key in [ 'codigo', 'tipo','permissao', 'autorizacao']" :key="key">
                        {{ key }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in mergedTableData" :key="rowIndex" @click="handleRowClick(row)" :class="{ 'selected': selectedRow.id === row.id ,'nonselected': selectedRow.id !== row.id }" >
                    <td v-for="key in [ 'codigo', 'tipo','permissao', 'autorizacao']" :key="key">
                        {{ row[key] }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="pagination" style="display: flex; gap: 0.5rem;">
            <button @click="prevPage" :disabled="currentPage === 1" style="cursor: pointer; color: var(--icon);"><</button>
            <span><!--Page--> {{ currentPage }} de {{ totalPages }}</span>
            <button @click="nextPage" :disabled="currentPage === totalPages" style="cursor: pointer; color: var(--icon);">></button>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/button.vue'
import AppTableFilter from '@/components/filter/tableFilter.vue'
import AppSearch from '@/components/search.vue'

export default {
    name: 'AppTable',
    components: {
        AppButton,
        AppTableFilter,
        AppSearch,
    },
    props: {
        table_data: {
            type: Array,
            default: () => []
        },
        table_title: {
            type: String,
            default: () => "Table Title"
        },
        show: {
            type: Boolean,
            default: () => false
        },
        visibility: {
            type: Boolean,
            default: () => false
        },
        filter_data: {
            type: Object,
            default: () => ({})
        },
        columnsToHide: {
      type: Array,
      default: () => [],
    },
    },
    created() {
        this.hideColumn('Tipo');
    },
    watch: {
        columnsToHide: {
            handler(newValue) {
                console.log("New columns to hide: ", newValue);
            },
            deep: true,
        },
        table_data: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.filter_data = this.addTrueValues(newVal[0]);
                }
            },
            immediate: true
        }
    },
    methods: {
        handleRowClick(row) {
        this.selectedRow = row;
        this.$emit('row-clicked', row);
        console.log('Selected Row:', row);

        
        },
        delete_onClick(row) {
            this.$emit("delete_data", row);
        },
        close() {
            this.$emit('close');
        },
        addTrueValues(obj) {
            let newObj = {};
            for (let key in obj) {
                newObj[key] = true;
            }
            return newObj;
        },
        updateFilter({ property, value }) {
            this.filter_data[property] = value;
        },
        getSearch(text) {
            this.search_text = text;
        },
        applySearchFilter(data) {
            if (!this.search_text) {
                return data;
            }

            return data.filter(row => {
                for (let key in row) {
                    if (Object.prototype.hasOwnProperty.call(row, key) && typeof row[key] === 'string' && row[key].toLowerCase().includes(this.search_text.toLowerCase())) {
                        return true;
                    }
                    else if (Object.prototype.hasOwnProperty.call(row, key) && typeof row[key] === 'number' && row[key] == parseInt(this.search_text)) {
                        return true;
                    }
                }
                return false;
            });
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        hideColumn(columnKey) {
            this.columnsToHide.push(columnKey);
        }
    },
    data() {
        return {
            filter_data: {},
            search_text: "",
            perPage: 10,
            currentPage: 1,
            selectedRow: {},
            // columnsToHide: []
        }
    },
    mounted() {
        console.log('Filtered Data',this.filteredTableData[0]);
    },

    computed: {
        perPageOptions() {
            return [5, 10, 15, 20];
        },
        filteredTableData() {
            return this.table_data.map(row => {
                let filteredRow = {};
                for (let key in row) {
                    if (this.filter_data[key]) {
                        filteredRow[key] = row[key];
                    }
                }
                return filteredRow;
            });
        },
        searchedTableData() {
            return this.applySearchFilter(this.table_data);
        },
        totalPages() {
            return Math.ceil(this.searchedTableData.length / this.perPage);
        },
        displayedTableData() {
            const startIndex = (this.currentPage - 1) * this.perPage;
            const endIndex = startIndex + this.perPage;
            return this.searchedTableData.slice(startIndex, endIndex);
        },
        mergedTableData() {
            const mergedData = [];
            const filteredData = this.filteredTableData;
            const displayedData = this.displayedTableData;

            if (filteredData && filteredData.length > 0) {
                const filteredKeys = Object.keys(filteredData[0]);

                for (let i = 0; i < displayedData.length; i++) {
                    const row = displayedData[i];
                    const mergedRow = {};

                    for (const key of filteredKeys) {
                        mergedRow[key] = row[key];
                    }

                    mergedData.push(mergedRow);
                }
            }

            return mergedData;
        }
    }
}
</script>




<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter&family=Montserrat:wght@600&family=Poppins:wght@600&display=swap');

.table_wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: var(--fundoForm);
    padding: 2rem;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    color: var(--label);
    overflow-x: auto;

}

.title_table {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.title_settings {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.table_title {
    font-size: 16px;
    color: var(--titulo);
}

.close_btn_div {
    display: flex;
    align-self: flex-end;
    gap: 0.3rem;
}

.table_wrapper table {
    color: var(--label);
    table-layout: fixed;
    min-width: 600px;
    width: 100%;
    max-height: 253px;
    overflow-y: auto;
    gap: 1rem;
    border-collapse: separate;
    border-spacing: 0 0.3em;
}

thead {
    background-color: var(--colunaLista);
    width: 100%;
    height: 25px;
    border-radius: 8px;

}

th {
    font-size: 14px;
    text-align: left;
    padding-left: 0.5rem;
    text-transform: capitalize;
    font-weight: 400;
 
}

tbody {
    width: 100%;
}


tbody tr {
    height: 25px;
    cursor: pointer;
    margin-bottom: 1em;
}

tbody tr:hover td {
    background: var(--scroll);
}


.nonselected td {
    /* color: white; */
    background-color: var(--linhaLista); 
    font-size: 10px;
    text-align: left;
    padding-left: 0.5rem;
    /* white-space: nowrap; */
    border: none;
    
    /* Add this line */
}

.selected td {
    background-color: var(--scroll);
    font-size: 10px;
    /* background-color: #626288; */
    text-align: left;
    padding-left: 0.5rem;
    /* white-space: nowrap; */
    border: none;
    /* color: var(--icon); */
}

td:first-child,
th:first-child {
    border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
    border-radius: 0 8px 8px 0;
}



@media (max-width: 768px) {
    .table_wrapper {
        /* Styles for screens smaller than 768px */
        font-size: 0.8em;
    }
}

@media (min-width: 769px) {
    .table_wrapper {
        /* Styles for screens larger than 768px */
        font-size: 1em;
    }
}
</style>






```